import { useNavigate } from 'react-router-dom'

import { Icon } from '@paysense-india-services/elevate-web'

import styles from './index.module.scss'

const EmiCard = ({ item, onClick }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick(item)
    } else if (item.route) {
      navigate(item.route)
    }
  }

  return (
    <div className={`${styles.emiCardWrapper} ew-d-flex ew-gap-10`} onClick={handleClick}>
      <div
        className={`${styles.iconContainer} ew-border ew-rounded-md ew-p-8 ew-d-flex ew-align-items-center ew-justify-content-center`}>
        <img alt='Rupee' height={31} src={item?.leadingIcon} width={31} />
      </div>
      <div className='ew-d-flex ew-flex-column ew-flex-grow-1'>
        <div className='ew-fw-semi-bold ew-color-primary'>{item.loanAmount}</div>
        <div className='ew-typography-small ew-fw-regular ew-color-secondary'>
          {item.emiDetails}
        </div>

        {item.status ? (
          <div
            className='ew-mt-2 ew-typography-tiny ew-fw-semi-bold'
            style={{ color: item.statusColor }}>
            {item.status}
          </div>
        ) : null}
      </div>
      {item.showArrow ? (
        <div
          className={`ew-d-flex ew-align-items-center ew-justify-content-center ew-bg-secondary ${styles.arrowContainer}`}>
          <Icon fill='#171717' name='rightArrowHead' size={14} />
        </div>
      ) : null}
    </div>
  )
}
export default EmiCard
